import React from "react";
import { Loader2 } from "lucide-react";
import CommonModal from "../../../../Settings/components/ResetContext/components/DumpModal";
import { Input } from "components/ui/input";
import { Button } from "components/ui/button";

const DeleteTaskModal = ({
  isOpen,
  isScheduledTask,
  loading,
  onClose,
  onConfirm,
}) => {
  const [input, setInput] = React.useState("");
  return (
    <CommonModal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <p className="font-bold text-[18px] text-center text-foreground">
          Delete Tasks
        </p>
      }
      showAlert={false}
    >
      <div className="scrollable-modal-content !p-0">
        <p className="bg-destructive/10 border border-destructive/30 text-foreground p-4 rounded mb-6 text-center font-[600]">
          <span className="mr-3">⚠️</span>{" "}
          <span>
            You're about to delete this task. This action is permanent and
            cannot be undone.
          </span>
        </p>
        <div>
          <p className="mb-2 text-[14px] text-muted-foreground">
            Type <span className="font-[600] text-foreground">DELETE</span> to proceed
          </p>
          <Input
            type="text"
            className="mb-3"
            placeholder="Type DELETE to proceed"
            value={input}
            onChange={(e) => setInput(e.target.value)}
          />
        </div>
        <div className="w-full flex gap-4">
          <Button
            type="button"
            variant="destructive"
            className="w-full"
            disabled={input !== "DELETE" || loading}
            onClick={onConfirm}
          >
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Delete Tasks"}
          </Button>
        </div>
      </div>
    </CommonModal>
  );
};

export default DeleteTaskModal;
